import { SNAPSHOT_EVENT_NAME } from './constants';
import { validateEmployeeId } from './validators/validate-employee-id';

export function openGlobalSnapshot(employeeId: string | number): void {
	if (validateEmployeeId(employeeId)) {
		const event = new CustomEvent(SNAPSHOT_EVENT_NAME, {
			detail: { open: true, employeeId },
		});
		window.dispatchEvent(event);
	}
}
